import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import React from "react";

export default function SuccessBuy({ onClose, isOpen, product }) {
  const cancelRef = React.useRef();
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader>Berhasil</AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody py="5">
          Produk <b>{product}</b> berhasil ditambahkan
        </AlertDialogBody>
      </AlertDialogContent>
    </AlertDialog>
  );
}
